import { FinancialServiceProviderAdapters } from '@seapoint/server/enums';
import { AccountView } from '../../types/entity-types';

type AccountDisplayNameArgs = Pick<AccountView, 'displayName' | 'institution' | 'currency' | 'fspAdapter'>;

/**
 * Get the display name for an account with currency suffix.
 *
 * For Stripe accounts: displayName + currency (e.g., "Ivan's Business (USD)")
 * For other accounts: institution.name + currency, or displayName as-is (already includes currency)
 */
export function getAccountDisplayName(account: AccountDisplayNameArgs): string {
  // Stripe stores displayName without currency - add it for display
  if (account.fspAdapter === FinancialServiceProviderAdapters.STRIPE && account.displayName) {
    return `${account.displayName} (${account.currency})`;
  }

  // Other adapters: prefer institution name + currency
  if (account.institution?.name) {
    return `${account.institution.name} (${account.currency})`;
  }

  // Fallback to displayName (already includes currency for non-Stripe) or generic
  return account.displayName ?? `Account (${account.currency})`;
}
